import React from 'react'
import Sidebar from './Sidebar'
import '../styles/layout.css'

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  )
}

export default Layout

